import { combineReducers } from 'redux';
import { authReducer } from './auth/auth.reducers';
import { loggedUserReducer } from './loggedUser/logged.user.reducer';

export const rootReducer = combineReducers({
    loggedUserReducer,
    authReducer,
});
